module.exports = __webpack_public_path__ + "static/img/14.a845661.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/7/14.png
// module id = /2tA
// module chunks = 0